module.exports = __webpack_public_path__ + "/login_ui/img/ai-134cde68b1b03b7b428006b9a17c3f26.svg";